module.exports = __webpack_public_path__ + "tree-half-round.svg?b977d51bd7bc9c5af51dd877f80323c6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tree-half-round.svg
// module id = 159
// module chunks = 0